<template>
    <div class="testimonial-list grid grid__base" :class="rootClasses">
        <div class="testimonial-list--container grid--container">
            <div class="testimonial-list--wrapper-row grid--row">
                <div class="testimonial-list--wrapper-col grid--col">
                    <slot/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [
            bemMixin('testimonial-list'),
        ],
        props: {
            itemCount: {
                type: Number,
                default: 0,
            },

            facet: {
                type: String,
                default: 'base',
            },
        },

        computed: {
            rootClasses() {
                let sizeFacet = 'large';
                if (this.itemCount === 2) {
                    sizeFacet = 'medium';
                } else if (this.itemCount > 2) {
                    sizeFacet = 'small';
                }

                return [
                    this.bemAdd(this.facet),
                    this.bemAdd(sizeFacet),
                ];
            },
        },
    };
</script>
